// extracted by mini-css-extract-plugin
export var qaWrapper = "QABlock-module--qaWrapper--c6c01";